export default __webpack_public_path__ + "header.03c3775c.png";